module.exports = __webpack_public_path__ + "static/media/feishu1.2582890e.mp4";